import { AbstractControl, FormControl, UntypedFormBuilder, UntypedFormGroup, Validators, ValidationErrors, ValidatorFn } from '@angular/forms';
import { AlertClassColour, ApplicationNames, ConfigSystemParamDefaults, ConfigSystemParams, modalFormValues, msSize, TypeDevice } from 'src/app/core/consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, throwError } from 'rxjs';
import { CompletedModalFormComponent } from 'src/app/forms-modal/_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { DeviceDTO } from 'src/app/core/models/system/device/device.dto';
import { DevicesService } from 'src/app/core/services/utelize/system/device/devices-service';
import { EsimProvisioningDTO } from 'src/app/core/models/system/provisioning/esim-provisoning.dto';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { InviewUserDTO } from 'src/app/core/models/inview/inview-user.dto';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { LicencesCompanyAllocatedService } from 'src/app/core/services/utelize/system/licence/licences-company-allocated-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderDTO } from 'src/app/core/models/system/order/order.dto';
import { OrderMiniDTO } from 'src/app/core/models/system/order/order-mini.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { UserDTO } from 'src/app/core/models/system/user/user.dto';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { ValidatorService } from 'src/app/core/services/utelize/general/validator-service';
import { WarningModalFormComponent } from 'src/app/forms-modal/_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-imei-locking-modal-form',
  templateUrl: './imei-locking-modal-form.component.html',
  styleUrls: ['./imei-locking-modal-form.component.scss']
})

export class ImeilockingModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Input() embeddedFormMode      : boolean | undefined;

  @Output() imeiLockingOrderUpdated : EventEmitter<IdAndDescriptionDTO>=new EventEmitter<IdAndDescriptionDTO>();
  @Output() imeiLockingCancelled    : EventEmitter<void>=new EventEmitter<void>();
  @Output() imeiLockingSuccessful   : EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('completedModalForm',         { static: false }) completedModalForm!         : CompletedModalFormComponent;
  @ViewChild('imeifield',                  { static: false }) imeiInput!                  : ElementRef<HTMLInputElement>;
  @ViewChild('imeiLockingModalFormContent',{ static: false }) imeiLockingModalFormContent!: TemplateRef<void>;
  @ViewChild('warningModalForm',           { static: false }) warningModalForm!           : WarningModalFormComponent;
  
  get modalBackGround()               { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                                        return value=value.toUpperCase()=="STATIC" ? "static"     : (value.toUpperCase()=="TRUE" ? true : false) }
  
  get mustHaveLicence() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.LicencesPlatformMustHaveForProvision, false); }

  private completedOrderStatus          : string="IMEI Locked";
  private device                        : DeviceDTO | undefined;
  private initialStatus                 : string="Please complete the following details";
  private initialOrderStatus            : string="Pending";
  private imeilockingModalFormRef!      : NgbModalRef;
  private selectedDeviceTypeId          : number=0;
  private selectedInviewCompany?        : IdAndDescriptionDTO;
  private sureSimOrder                  : OrderDTO | undefined;
  private sureSimOrderUpdated           : boolean=false;

  public imeilockingForm!               : UntypedFormGroup;
  public alertColourOrderStatus         : string=AlertClassColour.Grey;
  public alertColourProgress            : string=AlertClassColour.Grey;
  public availableOnly                  : boolean=false;
  public breadCrumbItems!               : Array<{}>;
  public currUser                       : SystemUserDTO;
  public existingImei                   : string="";
  public existingImeiLock               : string="";
  public formSubmitted                  : boolean=false;
  public formTitleDefault               : string="IMEI Locking";
  public formTitle                      : string=this.formTitleDefault;
  public imeiLock                       : string="";
  public imeiRadioSelection             : string="";
  public inviewUserData                 : InviewUserDTO | undefined;
  public orderStatusInformation         : string=this.initialOrderStatus;
  public placeholderText                : string="Off";
  public preventAutofill                : boolean=true;
  public imeilockingInProgress          : boolean=false;
  public progressInformation            : string=this.initialStatus;
  public imeilockingButtonEnabled       : boolean=false;
  public imeilockingButtonText          : string="Apply Lock";
  public searchForInviewUser            : boolean=false;
  public selectedInviewCompanyId        : number | undefined;
  public selectedInviewUserId           : number | undefined;
  public sureSimOrderDetails            : OrderMiniDTO | undefined;
  public sureSimUser                    : UserDTO | undefined;
  public warningMessageMain             : string | undefined;
  public warningMessageSub              : string | undefined;

  constructor(
    private authenticationService          : AuthenticationService,
    private configSystemService            : ConfigSystemService,
    private exceptionsService              : ExceptionsService,
    private devicesService                 : DevicesService,
    private formBuilder                    : UntypedFormBuilder,
    private lastPassKillerService          : LastPassKillerService,
    private licencesCompanyAllocatedService: LicencesCompanyAllocatedService,
    private modalService                   : NgbModal,
    private ordersService                  : OrdersService,
    private usersService                   : UsersService,
    private validatorService               : ValidatorService
  ) {
    this.currUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {
      this.orderStatusInformation=this.initialOrderStatus;

      if (this.embeddedFormMode) {
        this.startProcess(true);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    try {
      this.lastPassKillerService.stop();
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeForm(): void {
    try {
      this.imeiLockingCancelled.emit();

      if (this.imeilockingModalFormRef != undefined) {
        this.imeilockingModalFormRef.close();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getSureSimOrder() {
    try {
      this.ordersService.getById(<number>this.sureSimOrderDetails?.orderID)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder=data;
          this.getUser(this.sureSimOrder?.userID ?? -1);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public getUser(suresimUserId:number) {
    this.usersService.getById(suresimUserId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimUser=data;
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
  }
 
  public resetMainVariables(IsFormOpening : boolean): void {
    try {
      this.alertColourProgress           =AlertClassColour.Grey;
      this.formSubmitted                 =false;
      this.formTitle                     =this.formTitleDefault + ' - ' + (this.sureSimOrderDetails?.iccid ?? "");
      this.progressInformation           =this.initialStatus;
      this.imeilockingButtonEnabled      =false;
      this.imeilockingButtonText         ="Apply Lock";
      this.imeiRadioSelection            ="";
      this.selectedInviewCompanyId       =undefined;
      this.selectedInviewUserId          =undefined;
      this.imeilockingInProgress         =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public openForm(sureSimOrderDetails: OrderMiniDTO, deviceTypeId: number, imeiLock: string, imei: string): void {
    try {
      this.imeiLock             = imeiLock;
      this.existingImei         = imei,
      this.existingImeiLock     = imeiLock;
      this.sureSimOrderDetails  = sureSimOrderDetails;
      this.selectedDeviceTypeId = deviceTypeId
      this.availableOnly        = true;

      this.getSureSimOrder();
      this.startProcess(true);
      this.openModal();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openModal(): void {
    try {
      this.imeilockingModalFormRef = this.modalService.open(this.imeiLockingModalFormContent, { backdrop: this.modalBackGround, 
                                                                                         centered: true,
                                                                                         keyboard: false,
                                                                                         size    : msSize.Medium });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private startProcess(IsFormOpening : boolean): void {
    try {
      this.resetMainVariables(IsFormOpening);
      this.setUpForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region imeilockingForm

  get formData() {
    return this.imeilockingForm.controls;
  }

  private setUpForm() {
    try {
      //this.getOrder();
      this.buildForm();
      this.enableDisableControls(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.imeilockingForm=this.formBuilder.group({ });

      this.addFormFields(this.imeilockingForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public existingImeiRequiredValidator(existingImei:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const radioControl = parent.get("imeiRadio");
        var result = radioControl && radioControl.value == "existing" && (value != null && value != existingImei) ? { existingImeiRequired: true } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }

  public newImeiRequiredValidator(existingImei:string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      try {
        const value =control.value;
        const parent=control.parent;
        if (!parent) return null;
  
        const radioControl = parent.get("imeiRadio");
        var result = radioControl && radioControl.value == "specify" && (value != null && value == existingImei) ? { newImeiRequired: true } : null;
        return result;
      } catch (e) {
        this.exceptionsService.handleException(<Error>e);
        return null;
      }
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.imeilockingForm) {
        this.addFormControl(formGroup, "imeiRadio",            "", [Validators.required]);
        this.addFormControl(formGroup, "imeilock",  this.imeiLock, [Validators.required, Validators.minLength(14), Validators.maxLength(100), Validators.pattern(/^[0-9]+$/), this.existingImeiRequiredValidator(this.existingImei), this.newImeiRequiredValidator(this.existingImei)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
 
  // private removeFormFields(form: UntypedFormGroup) {
  //   try {
  //     if (form != undefined) {
  //       for (let control in form.controls) {
  //         form.removeControl(control);
  //       }
  //     }
  //   }
  //   catch(e) {
  //     this.exceptionsService.handleException(<Error>e);
  //   }
  // }
  
  public saveFormData() {
    try {
      this.formSubmitted=true;
 
      if (this.imeilockingForm.valid && 
         ((this.imeiRadioSelection == "existing" && this.imeilockingForm.controls["imeilock"].value == this.existingImei) ||
          (this.imeiRadioSelection != "existing" && this.imeilockingForm.controls["imeilock"].value != this.existingImei)))
      {
        if (this.imeilockingForm.controls["imeilock"].value != this.existingImeiLock)
        {
          this.saveOrder(this.sureSimOrderDetails!.iccid, this.imeilockingForm.controls["imeilock"].value);
        } else {
          this.doImeiLocking(this.sureSimOrderDetails!.iccid, this.imeilockingForm.controls["imeilock"].value);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public saveOrder(iccid:string, imei:string) {
    try {
      this.sureSimOrder!.imeiLocking    = this.imeilockingForm.controls["imeilock"].value;
      this.sureSimOrder!.updatedByUserId= this.currUser.userId;

      this.ordersService.save(<OrderDTO>this.sureSimOrder)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.sureSimOrder = data;
          this.sureSimOrderDetails!.orderID = <number>this.sureSimOrder?.id;
          this.sureSimOrderUpdated = true;
          this.doImeiLocking(iccid, imei);
         },
        error: error => {
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      if (enabled) {
        this.imeilockingForm.controls["imeilock"].enable();
      } else {
        this.imeilockingForm.controls["imeilock"].disable();
      }
      
      this.imeilockingButtonEnabled = ((this.imeiRadioSelection != ""       && this.imeilockingForm.controls["imeilock"].value != "") ||
                                       (this.imeiRadioSelection == "remove" && this.imeilockingForm.controls["imeilock"].value == ""));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private disableAllControls() {
    try {
      this.imeilockingForm.controls["imeilock"].disable();     
      this.imeilockingButtonEnabled      =false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public validateImeiLockInput() {
    try {     
      this.imeilockingButtonEnabled      = (this.imeiRadioSelection != "" && this.imeilockingForm.controls["imeilock"].value != "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  //#endregion

  //#region Imei Locking
  private doImeiLocking(iccid:string, imei:string): void {
    try {
      this.imeilockingInProgress = true;

      this.devicesService.lockImei(iccid, imei, this.currUser.userId)
      .pipe(
        catchError((error) => {
          this.imeilockingInProgress = false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          let imeiLockResult=data;
          this.orderStatusInformation = this.completedOrderStatus;
          this.imeilockingInProgress = false;

          if (this.sureSimOrderUpdated) {
            let ev : IdAndDescriptionDTO = {id:this.sureSimOrderDetails?.orderID ?? -1,description:this.sureSimOrder?.imeiLocking ?? ""};
            this.imeiLockingOrderUpdated.emit(ev);
          }

          this.processComplete();
        },
        error: error => {
          if (error.message && error.message.includes("404")) {
            this.imeilockingInProgress = false;
            this.enableDisableControls(false);

            this.warningMessageMain="Issue locking IMEI";
            this.warningMessageSub ="Please contact the application vendor for assistance";

            this.warningModalForm.openForm(this.warningMessageMain, this.warningMessageSub);
          } else {
            this.imeilockingInProgress = false;
            this.exceptionsService.handleException(new Error(error));
          }
        }
      });
    }
    catch(e) {
      this.imeilockingInProgress = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onRadioChange(radioClicked: string) : void
  {
    try {
      this.imeiRadioSelection  = radioClicked;
      if (radioClicked == "existing")
      {
        this.imeilockingForm.controls["imeilock"].setValue(this.existingImei);
        this.imeilockingButtonText = "Apply Lock";
      } else if (radioClicked == "remove") {
        this.imeilockingForm.controls["imeilock"].setValue("");     
        this.placeholderText       = "Off";
        this.imeilockingButtonText = "Remove Lock";
      } else {
        this.imeilockingForm.controls["imeilock"].setValue("");     
        this.placeholderText       = "";
        this.imeilockingButtonText = "Apply Lock";
      }
      this.enableDisableControls(radioClicked == "specify");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public removeLock(): void {
    this.imeilockingForm.controls["imeilock"].setValue("");
  }

  //#endregion

  //#region Process Complete

  private processComplete() {
    try {
      this.imeiLockingSuccessful.emit();
      this.completedModalForm.openForm("Congratulations", this.imeilockingButtonText == "Remove Lock" ? "The sim lock has been removed" : "This sim has been IMEI locked");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {
    try {
      this.closeForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
